import { publishAuthUserChanged, publishAuthUserClaimsChanged } from '@nbx/frontend-helpers/publish';
import { NBXStorage } from '@nbx/frontend-helpers/storage';
import authTypes from 'reduxConfig/auth.types';

const initialState = {
  error: null,
  loading: false,
  message: null,
  email: null,
  timeout: null,
  step: null,
  claims: {},
  user: null,
  userId: null,
  accountId: null,
  modal: null,
  firebaseAuthMobileState: null,
  phoneNumber: null,
  firebaseMfaVerificationId: null,
  firebaseMfaPhoneNumber: null,
  firebaseMfaResolver: null,
  firebaseUserCredential: null,
  referralCode: null,
  cardPartnershipCode: null,
  isEnrollFirebaseSms2faOnSignup: null,
  addPhoneNumberError: null
};

// eslint-disable-next-line default-param-last
function authReducer(state = initialState, action) {
  switch (action.type) {
    case authTypes.AUTH_CLEAR_ERROR: {
      return { ...state, error: null };
    }
    case authTypes.AUTH_SET_ERROR: {
      return { ...state, error: action.error };
    }
    case authTypes.AUTH_START_LOADING: {
      return { ...state, loading: true };
    }
    case authTypes.AUTH_STOP_LOADING: {
      return { ...state, loading: false };
    }
    case authTypes.AUTH_CLEAR_USER: {
      NBXStorage.removeItem('user');
      return { ...state, error: null, user: null };
    }
    case authTypes.AUTH_SET_CLAIMS: {
      publishAuthUserClaimsChanged(action.claims);
      return { ...state, claims: action.claims };
    }
    case authTypes.AUTH_SET_IDS: {
      return { ...state, userId: action.userId, accountId: action.accountId };
    }
    case authTypes.AUTH_SET_MESSAGE: {
      return { ...state, message: action.message };
    }
    case authTypes.AUTH_SET_VERIFICATION_TIME_OUT: {
      return { ...state, timeout: action.timeout };
    }
    case authTypes.AUTH_SET_VERIFICATION_EMAIL: {
      return { ...state, email: action.email };
    }
    case authTypes.AUTH_SET_STEP: {
      return { ...state, step: action.step };
    }
    case authTypes.AUTH_SET_USER: {
      const user = action.user ? { id: state.userId, ...action.user } : null;
      publishAuthUserChanged(user); // this was really really dirty idea to put side effects in the reducer
      return { ...state, user };
    }
    case authTypes.AUTH_SET_MODAL: {
      return { ...state, modal: action.modal };
    }
    case authTypes.AUTH_SET_FIREBASE_AUTH_MOBILE_STATE: {
      return { ...state, firebaseAuthMobileState: { idToken: action.idToken, email: action.email } };
    }
    case authTypes.AUTH_SET_PHONE_NUMBER: {
      return { ...state, phoneNumber: action.phoneNumber };
    }
    case authTypes.FIREBASE_MFA_SET_VERIFICATION_PROPS: {
      return {
        ...state,
        firebaseMfaResolver: action.resolver,
        firebaseMfaVerificationId: action.verificationId,
        firebaseMfaPhoneNumber: action.phoneNumber
      };
    }
    case authTypes.SET_REFERRALS: {
      return { ...state, referralCode: action.referralCode, cardPartnershipCode: action.cardPartnershipCode };
    }
    case authTypes.AUTH_SET_IS_ENROLL_FIREBASE_SMS_2FA_ON_SIGNUP: {
      return { ...state, isEnrollFirebaseSms2faOnSignup: action.value };
    }
    case authTypes.FIREBASE_ADD_PHONE_NUMBER_ERROR: {
      return { ...state, addPhoneNumberError: action.error };
    }
    default:
      return state;
  }
}

export default authReducer;
